export default "__VITE_ASSET__leRRIbWb__"